<template>
  <div class="sideSNSButton">
    <ul>
      <li area-label="Twitter">
<ShareNetwork
    network="twitter"
    :url=shareUrl
    :title=shareTitle
    :description=shareDescription
		:quote=shareDescription
    hashtags="ToyoshimaSeimitsu"
		role="link"
		aria-label="Xリンク"
>
<font-awesome-icon :icon="['fab','x-twitter']" alt="x-twitter"/>
</ShareNetwork>
      </li>
      <li area-label="Facebook">
<ShareNetwork
    network="facebook"
    url="https://toyoshimaseimitsu.co.jp/"
    title="豊嶋精密工業株式会社"
    description="豊嶋精密工業株式会社は1959年創業以来金属加工を行い、現在精密板金を専門としながら金属加工全般を請け負う会社です。経験と技術から難しい板金のご依頼も対応しています。"
    quote=""
    hashtags="ToyoshimaSeimitsu"
		role="link"
		aria-label="Facebookリンク"
><font-awesome-icon :icon="['fab', 'facebook']" alt="facebook"/>
</ShareNetwork>
      </li>
      <li area-label="Line">
<ShareNetwork
    network="line"
    :url=shareUrl
    :title=shareTitle
    description="豊嶋精密工業株式会社は1959年創業以来金属加工を行い、現在精密板金を専門としながら金属加工全般を請け負う会社です。経験と技術から難しい板金のご依頼も対応しています。"
		quote=""
    hashtags="ToyoshimaSeimitsu"
		role="link"
		aria-label="Lineリンク"
><font-awesome-icon :icon="['fab', 'line']" alt="line"/>
</ShareNetwork>
      </li>
<!--
      <li area-label="Instagram">
<ShareNetwork
    network="instagram"
    :url=shareUrl
    :title=shareTitle
    description="豊嶋精密工業株式会社は1959年創業以来金属加工を行い、現在精密板金を専門としながら金属加工全般を請け負う会社です。経験と技術から難しい板金のご依頼も対応しています。"
		quote=""
    hashtags="ToyoshimaSeimitsu"
		role="link"
		aria-label="Instagramリンク"
><font-awesome-icon :icon="['fab', 'instagram']" alt="instagram"/>
</ShareNetwork>
      </li>
-->
    </ul>
  </div>
</template>

<script>
/*import SocialSharing from 'vue-social-sharing'*/
/*
descriptionがメッセージに反映されないため、タイトルに付加して送付する
*/
export default {
  name:'Share',
  components:{ /*SocialSharing,*/ },
  data() {
    return {
			shareSiteName:"Rocked",
			shareTitle:"",
			shareUrl:"",
			shareDescription:"",
		}
	},
  computed: {
  },
  beforeMount:function() {this._log("beforeMount "+this.$options.name)
    this.$store.watch(
      (state, getters) => getters.currentTitle,
      (newValue, oldValue) => {
					this.shareTitle = this.$store.getters.currentTitle
					this.setShareInformation()
      }
    )
	},
  mounted: function() {
  },
  beforeUpdate:function() {this._log("beforeUpdate "+this.$options.name)
	},
  updated: function() {this._log("updated "+this.$options.name)
	},
  methods: {
		setShareInformation:function(){
			this.shareUrl = this.$store.getters.currentOgUrl
			this.shareTitle = this.shareTitle+ ":" + this.$store.getters.currentDescription
		},
  }
}
</script>

<style>
</style>